async function customRellax () {
  const getRellax = document.querySelector('.rellax')
  if (!getRellax) return

  // Destruir la instancia existente si la hay
  if (window.rellaxInstance) {
    window.rellaxInstance.destroy()
  }

  // Cargar Rellax si no está disponible
  if (!window.Rellax) {
    const module = await import('./rellax.min.js')
    window.Rellax = module.default || module
  }

  // Crear nueva instancia
  window.rellaxInstance = new window.Rellax('.rellax', {
    center: true
  })
}

export default customRellax
